import { configureStore /*getDefaultMiddleware*/ } from "redux-starter-kit";
import rootReducer from "./reducers";
/*import logger from "redux-logger";

const middleware = [...getDefaultMiddleware(), logger];*/

const store = configureStore({
  reducer: rootReducer
  //middleware
});

export default store;
